import {
  CollectionReference,
  DocumentData,
  DocumentReference,
  FirestoreError,
  QuerySnapshot,
  Unsubscribe,
  addDoc,
  collection,
  doc,
  getFirestore,
  onSnapshot,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { getRetrospectiveDocumentById } from './retrospectives';

export function getMoodsCollection(
  retrospectiveId: string
): CollectionReference<DocumentData> {
  return collection(getRetrospectiveDocumentById(retrospectiveId), 'moods');
}

/**
 * Get mood document by id
 * @param {string} retrospectiveId - The retrospective ID
 * @param {string} moodsId - The moods ID
 * @returns {DocumentReference<DocumentData>}
 */
export function getMoodsDocumentById(
  retrospectiveId: string,
  moodsId: string
): DocumentReference<DocumentData> {
  return doc(getFirestore(), getMoodsCollection(retrospectiveId).path, moodsId);
}

const createMood = async (retrospectiveId: string, questions, participant) => {
  const addParameters = {
    questions,
    createdOn: serverTimestamp(),
    participant,
  };

  const documentReference = await addDoc(
    getMoodsCollection(retrospectiveId),
    addParameters
  );

  return { id: documentReference.id, ...addParameters };
};

const updateMood = async (retrospectiveId: string, id: string, fields) => {
  await updateDoc(getMoodsDocumentById(retrospectiveId, id), fields);
};
const listenMoodsChange = (
  retrospectiveId: string,
  callback: (snapshot: QuerySnapshot) => void,
  errorCallback?: (error: FirestoreError) => void
): Unsubscribe => {
  return onSnapshot(
    getMoodsCollection(retrospectiveId),
    callback,
    errorCallback
  );
};

export { createMood, updateMood, listenMoodsChange };
